<template>
  <span :class="textClasses" :style="textStyle">{{ displayedValue }}</span>
</template>

<script>
import moment from 'moment'
import 'moment/locale/fr'
import displayMixin from './mixin'

export default {
  name: 'ConstructVisualDisplayDate',
  mixins: [displayMixin],
  computed: {
    rawValue() { return this.resolveValue(this.item.value, this.item.source, '') },
    parsedDate() {
      if (this.isEmptyDate(this.rawValue)) return null

      if (this.item.inputFormat) {
        const strictDate = moment(this.rawValue, this.item.inputFormat, true)
        return strictDate.isValid() ? strictDate : null
      }

      if (this.rawValue instanceof Date || typeof this.rawValue === 'number') {
        const nativeDate = moment(this.rawValue)
        return nativeDate.isValid() ? nativeDate : null
      }

      const knownDate = moment(this.rawValue, [
        moment.ISO_8601,
        'YYYY-MM-DD HH:mm:ss',
        'YYYY-MM-DD HH:mm',
        'YYYY-MM-DD',
        'DD/MM/YYYY HH:mm:ss',
        'DD/MM/YYYY HH:mm',
        'DD/MM/YYYY',
        'DD-MM-YYYY HH:mm:ss',
        'DD-MM-YYYY HH:mm',
        'DD-MM-YYYY',
      ], true)
      return knownDate.isValid() ? knownDate : null
    },
    displayedValue() {
      if (!this.parsedDate) return this.resolveTemplate(this.item.emptyText, '')
      const formattedDate = this.parsedDate.locale('fr').format(this.item.format || 'DD/MM/YYYY')
      return this.formatAffixedValue(
        formattedDate,
        this.resolveTemplate(this.item.prefix),
        this.resolveTemplate(this.item.suffix),
      )
    },
    textClasses() {
      return [
        this.item.size || 'body-2',
        { 'font-weight-bold': this.item.bold, 'font-italic': this.item.italic },
      ]
    },
    textStyle() {
      return {
        color: this.resolveValue(this.item.color, this.item.colorSource) || undefined,
      }
    },
  },
  methods: {
    isEmptyDate(value) {
      if (value === null || value === undefined || value === '' || value === 0 || value === '0') return true
      return /^0{4}-0{2}-0{2}(?:[ T]0{2}:0{2}(?::0{2})?)?$/.test(String(value).trim())
    },
  },
}
</script>
